/* this file added by Bearer Web Developer  */
import React from "react";
import styles from './showSortBasis.module.scss';
import { useAppState } from "../../../../states/app-state";
import { Button } from "@mui/material";
import { observer } from "mobx-react-lite";

const ShowSortBasis: React.FC = observer(() => {

    const appState = useAppState();
    const handleRemoveSortBasis = () => {
        appState?.ReservedOrders?.setSortBasis(null);
        appState?.ReservedOrders?.sortReservedOrdersList();
    }
    const sortText = appState?.ReservedOrders?.sortBasis === "creation_time" ? "Creation Time" : 'Expiry Time'
    // console.log({SortBasis:appState?.ReservedOrders?.sortBasis })
    return (
        <div className={styles.show_sort_basis}>
            {
                appState?.ReservedOrders?.sortBasis &&
                <div className={styles.sort}>Sort by {sortText} <Button onClick={handleRemoveSortBasis}>X</Button></div>
            }
        </div>
    )
})

export default ShowSortBasis;